import myShopClient from './nearlive';

/**
 * Send message to assistant backend
 *
 * @param {Object} params
 * @param {string} params.sessionId - Unique assistant session ID
 * @param {string} params.message - User message content
 * @param {Object} params.context - Onboarding context (step, shop data)
 * @param {Array} params.conversationHistory - Recent messages for context
 * @returns {Promise<{message: string}>}
 */
export async function sendMessage({ sessionId, message, context, conversationHistory }) {
	const client = await myShopClient();
	const { data } = await client.post('/api/assistant', {
		sessionId,
		message,
		context,
		conversationHistory
	});
	return data;
}

export default {
	sendMessage
};
